import { msgState } from "components";
import { SCheck, SCheckProps } from "components/parts";
import {
  useController,
  UseControllerProps,
  useFormContext,
} from "react-hook-form";
import { useSetRecoilState } from "recoil";

/**
 * コードチェックボックス
 */

/**
 * プロパティ
 */
type Props = Pick<UseControllerProps, "name" | "rules"> & {
  on: number | string;
  off: number | string;
} & Pick<
    SCheckProps,
    | "focusId"
    | "label"
    | "index"
    | "align"
    | "gridColumn"
    | "gridRow"
    | "disabled"
    | "onBlur"
    | "onChange"
    | "onKeyDown"
    | "onClick"
    | "onDoubleClick"
  >;

/**
 * コードチェックボックス
 *
 * @param name: フィールド名
 * @param rules: react-hook-formのルールを設定(必須はrequiredで指定する)
 * @param on: オンのコード値
 * @param off: オフのコード値
 * @param label: エラーメッセージ用のラベル
 * @param index: フォーカス番号(1～)
 * @param align: 文字位置
 * @param gridColumn: CSSグリッドの列位置を指定する
 * @param gridRow: CSSグリッドの行位置を指定する
 * @param disabled: 非活性
 *  * @returns JSX.Element
 */
export const SCodeCheck = ({
  name,
  rules,
  on,
  off,
  label,
  ...props
}: Props): JSX.Element => {
  // フォーム設定
  const { control, trigger, setValue } = useFormContext();
  const { field, fieldState } = useController({
    name,
    control,
    rules: rules,
  });

  // エラーメッセージ設定
  const setMsg = useSetRecoilState(msgState);

  return (
    <SCheck
      {...props}
      name={field.name}
      value={field.value}
      formRef={field.ref}
      onBlur={(event) => {
        trigger(name);
        props.onBlur?.call(this, event);
        setMsg(fieldState.error?.message || "");
      }}
      onChange={(event, checked) => {
        field.onChange(event);
        props.onChange?.call(this, event, checked);
        setValue(name, checked ? on : off);
      }}
      checked={field.value === on}
    />
  );
};
